import { environment } from "@environments/environment";
import { ProvideKeycloakOptions } from "keycloak-angular";

export function getKeycloakConfig(): ProvideKeycloakOptions {
    return {
        config: {
            url: environment.keycloak.url,
            realm: environment.keycloak.realm,
            clientId: environment.keycloak.clientId,
        },
        initOptions: {
            onLoad: "check-sso",
            pkceMethod: "S256",
            silentCheckSsoRedirectUri:
                window.location.origin + "/pages/silent-check-sso.html",
        },
        features: [],
        providers: [],
    };
}
